import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api, { formatError } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function PasswordRecovery() {
  const [params] = useSearchParams();
  const [token] = useState(() => { const value = params.get("token"); if (value) window.history.replaceState(null, "", "/recuperar-senha"); return value; });
  const [value, setValue] = useState(""); const [message, setMessage] = useState(""); const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const { data } = await api.post(token ? "/auth/reset-password" : "/auth/forgot-password", token ? { token, password: value } : { email: value });
      setMessage(data.message || "Senha redefinida. Entre com sua nova senha."); }
    catch (error) { setMessage(formatError(error)); } finally { setBusy(false); }
  };
  return <div className="min-h-screen flex items-center justify-center p-6"><Card className="glass w-full max-w-md"><CardContent className="p-6 space-y-4">
    <h1 className="text-2xl font-bold">Recuperar acesso</h1><form onSubmit={submit} className="space-y-4">
      <Label>{token ? "Nova senha" : "E-mail"}</Label><Input type={token ? "password" : "email"} minLength={token ? 8 : undefined} maxLength={token ? 72 : undefined} required value={value} onChange={(e) => setValue(e.target.value)} />
      <Button disabled={busy} type="submit">{token ? "Redefinir senha" : "Enviar instruções"}</Button></form>
    {message && <p role="status" className="text-sm">{message}</p>}<Link to="/login" className="underline text-sm">Voltar para o login</Link>
  </CardContent></Card></div>;
}
